var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_11799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11.25H5C5.34375 11.25 5.625 10.9688 5.625 10.625C5.625 10.2812 5.34375 10 5 10H2.5C2.15625 10 1.875 10.2812 1.875 10.625C1.875 10.9688 2.15625 11.25 2.5 11.25ZM1.875 4.375C1.875 4.71875 2.15625 5 2.5 5H12.5C12.8438 5 13.125 4.71875 13.125 4.375C13.125 4.03125 12.8438 3.75 12.5 3.75H2.5C2.15625 3.75 1.875 4.03125 1.875 4.375ZM2.5 8.125H8.75C9.09375 8.125 9.375 7.84375 9.375 7.5C9.375 7.15625 9.09375 6.875 8.75 6.875H2.5C2.15625 6.875 1.875 7.15625 1.875 7.5C1.875 7.84375 2.15625 8.125 2.5 8.125Z",
    fill: "#2457C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_11799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.644456adf1b8856e75b12ef6364e8c99.svg";
export { ForwardRef as ReactComponent };